import e from "react";
import { getIconColor as c } from "./iconfont.es5470.js";
import p from "./iconfont.es5471.js";
const f = {
  display: "block"
}, Z = ({ size: l = 16, useVw: F, useRem: n, color: a, withColor: t, removeClassName: E, disableSSR: m, style: h, ...v }) => {
  const d = h ? { ...f, ...h } : f;
  return /* @__PURE__ */ e.createElement(p, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "xinshouzhuanqulihe", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 41 41", width: F ? ((l || 0) / 375 * 100).toFixed(5) + "vw" : l + (n ? "rem" : "px"), height: F ? ((l || 0) / 375 * 100).toFixed(5) + "vw" : l + (n ? "rem" : "px"), className: E ? "" : "iconpark-icon", style: d, fill: "none", ...v }, /* @__PURE__ */ e.createElement(
    "g",
    {
      clipPath: "url(#1258b1__a)"
    },
    /* @__PURE__ */ e.createElement(
      "mask",
      {
        height: "41",
        width: "41",
        y: "0",
        x: "0",
        maskUnits: "userSpaceOnUse",
        style: { maskType: "luminance" },
        id: "1258b1__b"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 0, "#fff") : "#fff",
          d: "M.5.926h39.574V40.5H.5V.926Z"
        }
      )
    ),
    /* @__PURE__ */ e.createElement(
      "g",
      {
        mask: "url(#1258b1__b)"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 1, "#FBBB7F") : "#FBBB7F",
          d: "M1.817 23.159a5.044 5.044 0 0 1 5.046-5.047H33.65a5.046 5.046 0 0 1 5.046 5.047V34.21a5.046 5.046 0 0 1-5.046 5.046H6.863a5.046 5.046 0 0 1-5.046-5.046V23.159Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 2, "#3566F8") : "#3566F8",
          d: "M1.817 23.159a5.044 5.044 0 0 1 5.046-5.047H33.65a5.046 5.046 0 0 1 5.046 5.047V34.21a5.046 5.046 0 0 1-5.046 5.046H6.863a5.046 5.046 0 0 1-5.046-5.046V23.159Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 3, "#FED8B4") : "#FED8B4",
          d: "M1.02 13.886A5.044 5.044 0 0 1 6.064 8.84h28.377a5.046 5.046 0 0 1 5.046 5.046v3.449c0 .9-.733 1.63-1.631 1.63H2.649a1.63 1.63 0 0 1-1.63-1.63v-3.449Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 4, "#C2D2FD") : "#C2D2FD",
          d: "M1.02 13.886A5.044 5.044 0 0 1 6.064 8.84h28.377a5.046 5.046 0 0 1 5.046 5.046v3.449c0 .9-.733 1.63-1.631 1.63H2.649a1.63 1.63 0 0 1-1.63-1.63v-3.449Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 5, "#FED8B4") : "#FED8B4",
          d: "M1.02 17.185a5.044 5.044 0 0 1 5.045-5.046h28.377a5.046 5.046 0 0 1 5.046 5.046v3.448c0 .9-.733 1.631-1.631 1.631H2.649a1.63 1.63 0 0 1-1.63-1.63v-3.449Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 6, "#fff") : "#fff",
          d: "M1.02 17.185a5.044 5.044 0 0 1 5.045-5.046h28.377a5.046 5.046 0 0 1 5.046 5.046v3.448c0 .9-.733 1.631-1.631 1.631H2.649a1.63 1.63 0 0 1-1.63-1.63v-3.449Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 7, "#FED8B4") : "#FED8B4",
          d: "M1.02 18.385a5.044 5.044 0 0 1 5.045-5.046h28.377a5.046 5.046 0 0 1 5.046 5.046v3.447c0 .9-.733 1.631-1.631 1.631H2.649a1.63 1.63 0 0 1-1.63-1.63v-3.448Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 8, "#fff") : "#fff",
          d: "M1.02 18.385a5.044 5.044 0 0 1 5.045-5.046h28.377a5.046 5.046 0 0 1 5.046 5.046v3.447c0 .9-.733 1.631-1.631 1.631H2.649a1.63 1.63 0 0 1-1.63-1.63v-3.448Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 9, "#FED8B4") : "#FED8B4",
          d: "M1.02 17.925a5.046 5.046 0 0 1 5.045-5.049h28.377a5.046 5.046 0 0 1 5.046 5.046v3.449c0 .9-.733 1.63-1.631 1.63H2.649a1.63 1.63 0 0 1-1.63-1.63v-3.449.003Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 10, "#4D7AFE") : "#4D7AFE",
          d: "M1.02 17.925a5.046 5.046 0 0 1 5.045-5.049h28.377a5.046 5.046 0 0 1 5.046 5.046v3.449c0 .9-.733 1.63-1.631 1.63H2.649a1.63 1.63 0 0 1-1.63-1.63v-3.449.003Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 11, "#F2BA80") : "#F2BA80",
          d: "M16.754 7.73h8.272v32.545h-8.272V7.731Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 12, "#F2BA80") : "#F2BA80",
          d: "M16.754 7.73h8.272v32.545h-8.272V7.731Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 13, "#F2C68F") : "#F2C68F",
          d: "M16.754 38.584h8.272v1.692h-8.272v-1.695.003Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 14, "#FFECC4") : "#FFECC4",
          d: "M16.754 12.139h8.272v1.02h-8.272v-1.02Zm0 2.042h8.272v1.02h-8.272v-1.02Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 15, "#FBD290") : "#FBD290",
          d: "M16.754 15.203h8.272v1.02h-8.272v-1.02Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 16, "#FFF5E1") : "#FFF5E1",
          d: "M16.754 13.158h8.272v1.023h-8.272v-1.023Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 17, "#FDCB7F") : "#FDCB7F",
          d: "M9.4 3.294c-.72.246-1.17.615-1.377 1.152-.282.723-.27 1.625.06 2.305.3.61.876 1.104 1.98 1.104h10.184l-.258-.201c-.39-.306-.821-.672-1.265-1.046l-.516-.432a28.513 28.513 0 0 0-1.997-1.556c-1.415-.985-2.839-1.655-4.227-1.655-.927 0-1.84.077-2.58.329H9.4Zm11.58 4.558h10.088c1.115 0 1.748-.51 2.063-1.121a2.523 2.523 0 0 0 .01-2.208c-.163-.327-.63-.734-1.447-1.066a7.032 7.032 0 0 0-2.544-.496c-1.39 0-2.783.67-4.172 1.65a28.54 28.54 0 0 0-1.966 1.559l-.435.369c-.464.395-.92.786-1.337 1.109l-.26.204ZM8.744 1.367c1.057-.36 2.24-.441 3.24-.441 2.017 0 3.864.96 5.39 2.02.737.524 1.451 1.08 2.14 1.665l.559.467.542.459.608-.52.472-.4a30.737 30.737 0 0 1 2.108-1.665C25.3 1.891 27.128.926 29.15.926a9.03 9.03 0 0 1 3.312.647c.995.405 2.019 1.064 2.507 2.054a4.557 4.557 0 0 1-.027 4.036c-.666 1.305-2.003 2.23-3.873 2.23h-21.01c-1.883 0-3.172-.944-3.808-2.252a5.04 5.04 0 0 1-.126-3.933c.498-1.28 1.545-1.98 2.617-2.341h.003Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 18, "#FFF7E8") : "#FFF7E8",
          d: "M9.4 4.985c-.72.246-1.17.615-1.377 1.152-.282.723-.27 1.624.06 2.305.3.61.876 1.104 1.98 1.104h10.184l-.258-.201c-.39-.306-.821-.672-1.265-1.046l-.516-.432a28.51 28.51 0 0 0-1.997-1.556c-1.415-.985-2.839-1.655-4.227-1.655-.927 0-1.84.078-2.58.329H9.4Zm11.58 4.56h10.088c1.115 0 1.748-.509 2.063-1.12a2.523 2.523 0 0 0 .01-2.207c-.163-.33-.63-.735-1.447-1.067a7.031 7.031 0 0 0-2.544-.495c-1.39 0-2.783.668-4.172 1.649a28.614 28.614 0 0 0-1.966 1.556l-.435.371c-.464.396-.92.786-1.337 1.11l-.26.204ZM8.744 3.059c1.057-.36 2.24-.441 3.24-.441 2.017 0 3.864.959 5.39 2.02a30.78 30.78 0 0 1 2.14 1.665l.559.468.542.458.608-.519.472-.401a30.737 30.737 0 0 1 2.108-1.665c1.501-1.061 3.327-2.026 5.349-2.026a9.03 9.03 0 0 1 3.312.647c.995.405 2.018 1.064 2.507 2.054a4.556 4.556 0 0 1-.027 4.036c-.666 1.304-2.003 2.23-3.873 2.23H10.059c-1.883 0-3.172-.944-3.808-2.251A5.04 5.04 0 0 1 6.125 5.4c.498-1.28 1.545-1.98 2.617-2.341h.003Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 19, "#FFDEA2") : "#FFDEA2",
          d: "M9.4 5.513c-.72.246-1.17.615-1.377 1.151-.282.723-.27 1.626.06 2.303.3.612.876 1.11 1.98 1.11h10.184l-.258-.21c-.39-.303-.821-.67-1.265-1.044l-.516-.432a28.516 28.516 0 0 0-1.997-1.556c-1.415-.984-2.839-1.655-4.227-1.655-.927 0-1.84.078-2.58.33l-.004.003Zm11.58 4.557h10.088c1.115 0 1.748-.51 2.063-1.12a2.523 2.523 0 0 0 .01-2.208c-.163-.33-.63-.734-1.447-1.067a7.031 7.031 0 0 0-2.544-.495c-1.39 0-2.783.669-4.172 1.65a28.614 28.614 0 0 0-1.966 1.555l-.435.372c-.464.396-.92.786-1.337 1.11l-.26.203ZM8.744 3.582c1.057-.359 2.24-.438 3.24-.438 2.017 0 3.864.96 5.39 2.02a30.777 30.777 0 0 1 2.14 1.665c.37.308.736.616 1.101.926l.608-.518.472-.402a30.773 30.773 0 0 1 2.108-1.664c1.501-1.062 3.327-2.027 5.349-2.027 1.09 0 2.284.228 3.312.648.995.404 2.018 1.06 2.507 2.054a4.556 4.556 0 0 1-.027 4.035c-.666 1.305-2.003 2.231-3.873 2.231H10.059c-1.883 0-3.172-.943-3.808-2.252a5.04 5.04 0 0 1-.126-3.933c.498-1.28 1.545-1.98 2.617-2.345h.003Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 20, "#FFD391") : "#FFD391",
          d: "M18.209 2.634h5.229v9.607h-5.229V2.633v.001Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 21, "#FFECC4") : "#FFECC4",
          d: "M18.209 2.64h5.235v1.2h-5.235v-1.2Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 22, "#F9DCA9") : "#F9DCA9",
          d: "M18.209 5.042h5.235v1.2h-5.235v-1.2Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 23, "#F8D192") : "#F8D192",
          d: "M18.209 6.242h5.235V7.44h-5.235V6.241Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: t ? c(a, 24, "#FFF3D9") : "#FFF3D9",
          d: "M18.209 3.844h5.235v1.199h-5.235v-1.2Z"
        }
      )
    )
  ), /* @__PURE__ */ e.createElement(
    "defs",
    null
  ), /* @__PURE__ */ e.createElement(
    "clipPath",
    {
      id: "1258b1__a"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        transform: "translate(.5 .5)",
        fill: t ? c(a, 25, "#fff") : "#fff",
        d: "M0 0h40v40H0z"
      }
    )
  )));
}, B = Z;
export {
  B as default
};
